import axios from "axios";
import { returnErrors } from "../Redux/ActionCreators/errorAction";

// const AuthStr = "Bearer " + localStorage.getItem("token");
function getAuthHeader() {
  // SHARED MODE → ONLY use shared token
  if (window.isSharedReportMode === true) {
      const copied = localStorage.getItem("share_access_token_copied");
      const email = localStorage.getItem("share_access_token_email");
      const token = copied || email;

      if (!token) return ""; // no fallback to user token
      return `Bearer ${token}`;
  }

  // NORMAL MODE → ONLY use normal token
  const userToken = localStorage.getItem("token");
  return userToken ? `Bearer ${userToken}` : "";
}

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// Pass { auth: false } to call the endpoint without the Authorization header.
// null (not omitted) so axios also drops any global default Authorization.
function getJobApiCall(url, { auth = true } = {}) {

  return axios
    .get(process.env.REACT_APP_AI_API_KEY + url, {
      headers: {
        Authorization: auth ? getAuthHeader() : null,
        "X-User-Timezone": userTimezone,
      },
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      const status = error?.response?.status;
      const message =
        error?.response?.data?.responseMessages?.[0]?.message ||
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";

      return Promise.reject({
        isAxiosError: true,
        parsedStatus: status,
        parsedMessage: message,
        originalError: error,
      });
    });
}

function postJobApiCall(url, body) {
  return axios
    .post(process.env.REACT_APP_AI_API_KEY + url, body, {
      headers: { Authorization: getAuthHeader(), "X-User-Timezone": userTimezone,},
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      if (error?.response?.status === 402) throw error;
      if (error?.response?.status === 403) throw error;
      if (error?.response?.status === 409) throw error;
      return error;
    });
}


function putJobApiCall(url, body) {
  return axios
    .put(process.env.REACT_APP_AI_API_KEY + url, body, {
      headers: { Authorization: getAuthHeader(), "X-User-Timezone": userTimezone },
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      if (error?.response?.status === 402) throw error;
      returnErrors(
        error.response?.data?.responseMessages?.[0]?.message,
        error?.response?.status
      );
      return error;
    });
}

function deleteJobApiCall(url, body) {
  return axios
    .delete(process.env.REACT_APP_AI_API_KEY + url, {
      headers: { Authorization: getAuthHeader(), "X-User-Timezone": userTimezone },
      data: body,
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      returnErrors(
        error.response?.data?.responseMessages?.[0]?.message,
        error?.response?.status
      );
      return error;
    });
}

function getJobApiBlobCall(url) {
  return axios
    .get(process.env.REACT_APP_AI_API_KEY + url, {
      headers: { Authorization: getAuthHeader(), "X-User-Timezone": userTimezone },
      responseType: "blob",
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      returnErrors(
        error.response?.data?.responseMessages?.[0]?.message,
        error?.response?.status
      );
      return error;
    });
}

function patchJobApiCall(url, body) {
  return axios
  .patch(process.env.REACT_APP_AI_API_KEY + url, body, {
    headers: { Authorization: getAuthHeader(), "X-User-Timezone": userTimezone}
  })
  .then((data) => data)
  .catch((error) => {
    returnErrors(
        error.response?.data?.responseMessages?.[0]?.message,
        error?.response?.status
      );
      return error;
  })
}

function postJobApiBlobCall(url, body) {
  return axios
    .post(process.env.REACT_APP_AI_API_KEY + url, body, {
      headers: { Authorization: getAuthHeader(), "X-User-Timezone": userTimezone },
      responseType: "blob",
    })
    .then((data) => data)
    .catch((error) => {
      returnErrors(
        error.response?.data?.responseMessages?.[0]?.message,
        error?.response?.status
      );
      return error;
    });
}

function getJobApiTextCall(url) {
  return axios
    .get(process.env.REACT_APP_AI_API_KEY + url, {
      headers: {
        Authorization: getAuthHeader(),
        "X-User-Timezone": userTimezone,
        Accept: "text/html, application/json",
      },
      responseType: "text",
      transformResponse: [(data) => data],
    })
    .then((data) => data)
    .catch((error) => {
      const status = error?.response?.status;
      const message =
        error?.response?.data?.responseMessages?.[0]?.message ||
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";
      return Promise.reject({
        isAxiosError: true,
        parsedStatus: status,
        parsedMessage: typeof message === "string" ? message : "Something went wrong",
        originalError: error,
      });
    });
}

// FastAPI error bodies: 400 has a string `detail`, 422 has a list of `{ msg }`
// prefixed with "Value error, ". Accepts an axios error or a wrapped one.
function getApiErrorDetail(errOrRes) {
  const data = errOrRes?.response?.data || errOrRes?.originalError?.response?.data;
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => (typeof d?.msg === "string" ? d.msg.replace(/^Value error,\s*/, "") : ""))
      .filter(Boolean);
    if (msgs.length) return msgs.join(" ");
  }
  if (typeof detail?.message === "string") return detail.message;
  return data?.responseMessages?.[0]?.message || data?.message || "";
}

export {
  getApiErrorDetail,
  getJobApiCall,
  postJobApiCall,
  putJobApiCall,
  deleteJobApiCall,
  getJobApiBlobCall,
  getJobApiTextCall,
  patchJobApiCall,
  postJobApiBlobCall,
};
